import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AppContextProvider } from "@/Store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <BrowserRouter getUserConfirmation={() => {
      /* Empty callback to block the default browser prompt */
    }}>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </BrowserRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
